import bodyDetoxImg from "../assets/images/properties/body-detox.jpg";
import hairCareImg from "../assets/images/properties/hair-care.jpg";
import beautySkinImg from "../assets/images/properties/beauty-skin.jpg";
import painMassageImg from "../assets/images/properties/pain-massage.jpg";
import healthWellnessImg from "../assets/images/properties/health-wellness.jpg";

export const defaultStarterProperties = [
  {
    id: "prop_body_detox",
    label: "Body Detox Care",
    imageUrl: bodyDetoxImg,
    image: bodyDetoxImg,
    imageName: "body-detox.jpg",
    link: "/properties/prop_body_detox",
    accent: "#10b981",
    aspectRatio: "3:2",
    order: 1,
    isActive: true,
    description: "Natural detoxifying herbal blends formulated to cleanse, restore balance, and rejuvenate vitality.",
  },
  {
    id: "prop_hair_care",
    label: "Hair Care",
    imageUrl: hairCareImg,
    image: hairCareImg,
    imageName: "hair-care.jpg",
    link: "/properties/prop_hair_care",
    accent: "#f59e0b",
    aspectRatio: "3:2",
    order: 2,
    isActive: true,
    description: "Ayurvedic oils, serums, and natural remedies designed to nourish roots and promote healthy, lustrous hair.",
  },
  {
    id: "prop_beauty_skin",
    label: "Beauty & Skin Care",
    imageUrl: beautySkinImg,
    image: beautySkinImg,
    imageName: "beauty-skin.jpg",
    link: "/properties/prop_beauty_skin",
    accent: "#ec4899",
    aspectRatio: "3:2",
    order: 3,
    isActive: true,
    description: "Gentle botanicals and herbal extracts to hydrate, purify, and bring out your natural radiant glow.",
  },
  {
    id: "prop_pain_massage",
    label: "Pain & Massage Oils",
    imageUrl: painMassageImg,
    image: painMassageImg,
    imageName: "pain-massage.jpg",
    link: "/properties/prop_pain_massage",
    accent: "#f97316",
    aspectRatio: "3:2",
    order: 4,
    isActive: true,
    description: "Therapeutic warm herbal infusions crafted to ease joint soreness, relieve tension, and soothe tired muscles.",
  },
  {
    id: "prop_health_wellness",
    label: "Health & Wellness",
    imageUrl: healthWellnessImg,
    image: healthWellnessImg,
    imageName: "health-wellness.jpg",
    link: "/properties/prop_health_wellness",
    accent: "#6366f1",
    aspectRatio: "16:9",
    order: 5,
    isActive: true,
    description: "Holistic daily supplements and traditional Ayurvedic formulations for vitality, immunity, and well-being.",
  },
];

export const slugify = (text = "") => {
  return String(text)
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/[\s_-]+/g, "-")
    .replace(/^-+|-+$/g, "");
};

export const isProductLinkedToProperty = (product, property) => {
  if (!product || !property) return false;
  const propId = String(property.id || "").trim();
  const propLabel = String(property.label || property.title || "").trim().toLowerCase();

  const propList = Array.isArray(product.properties)
    ? product.properties
    : typeof product.properties === "string" && product.properties
    ? [product.properties]
    : [];

  return propList.some((p) => {
    if (!p) return false;
    if (typeof p === "string") {
      const val = p.trim();
      return (
        (propId && val === propId) ||
        (propLabel && val.toLowerCase() === propLabel) ||
        (propId && val.toLowerCase() === propId.toLowerCase())
      );
    }
    if (typeof p === "object") {
      const pId = String(p.id || "").trim();
      const pLabel = String(p.label || p.title || "").trim().toLowerCase();
      return (
        (propId && pId === propId) ||
        (propLabel && pLabel === propLabel) ||
        (propId && pId.toLowerCase() === propId.toLowerCase())
      );
    }
    return false;
  });
};

export const getProductsUsingProperty = (products, property) => {
  if (!Array.isArray(products) || !property) return [];
  return products.filter((product) => isProductLinkedToProperty(product, property));
};

export const findPropertyMatch = (propertiesList = [], propertyIdentifier = "") => {
  if (!propertyIdentifier) return null;
  const cleanId = String(propertyIdentifier).trim();
  const lowerId = cleanId.toLowerCase();
  const decodedLower = decodeURIComponent(cleanId).toLowerCase().trim();

  // 1. Direct ID match
  let found = propertiesList.find((p) => p.id === cleanId);
  if (found) return found;

  // 2. Case-insensitive ID match
  found = propertiesList.find((p) => String(p.id || "").toLowerCase() === lowerId);
  if (found) return found;

  // 3. Label exact match (decoded)
  found = propertiesList.find(
    (p) => String(p.label || p.title || "").trim().toLowerCase() === decodedLower
  );
  if (found) return found;

  // 4. Slugified match
  found = propertiesList.find(
    (p) => slugify(p.label || p.title || "") === slugify(decodedLower)
  );
  if (found) return found;

  // 5. Legacy def-1..def-5 mapping to default starter properties
  const legacyMap = {
    "def-1": "prop_body_detox",
    "def-2": "prop_hair_care",
    "def-3": "prop_beauty_skin",
    "def-4": "prop_pain_massage",
    "def-5": "prop_health_wellness",
  };
  if (legacyMap[lowerId]) {
    const targetStarterId = legacyMap[lowerId];
    found = propertiesList.find(
      (p) => p.id === targetStarterId || slugify(p.label || "") === slugify(targetStarterId)
    );
    if (found) return found;
  }

  // 6. Check default starter properties if not found in given propertiesList
  const starterMatch = defaultStarterProperties.find(
    (p) =>
      p.id === cleanId ||
      p.id.toLowerCase() === lowerId ||
      String(p.label).toLowerCase() === decodedLower ||
      slugify(p.label) === slugify(decodedLower) ||
      (legacyMap[lowerId] && p.id === legacyMap[lowerId])
  );
  if (starterMatch) return starterMatch;

  return null;
};
